<div class="wallboardViewSlide">
    <div [id]="wvf.Slides[wvf.CurrentSlide].WallboardSlideID + 'VideoPlayer'"></div>
</div>
